import { render, staticRenderFns } from "./UrlEmbed.vue?vue&type=template&id=26485cd0&"
import script from "./UrlEmbed.vue?vue&type=script&lang=js&"
export * from "./UrlEmbed.vue?vue&type=script&lang=js&"
import style0 from "./UrlEmbed.vue?vue&type=style&index=0&id=26485cd0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports